export const defaultItemPerPage = 10;
